import * as types from 'modules/questionModels/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} State */
const initialState = false;

const isStarted = () => true;

const isEnded = () => false;

export default createReducer(initialState, {
  [types.UPDATE_QUESTION_MODEL]: isStarted,
  [types.UPDATE_QUESTION_MODEL_SUCCESS]: isEnded,
  [types.UPDATE_QUESTION_MODEL_FAILURE]: isEnded,
  [types.CREATE_QUESTION_MODEL]: isStarted,
  [types.CREATE_QUESTION_MODEL_SUCCESS]: isEnded,
  [types.CREATE_QUESTION_MODEL_FAILURE]: isEnded,
});
